import FilterForm from '../../../components/forms/FilterForm';
import { Col, Form, Input, Row, Space, Table } from 'antd';
import { CrudFilters, HttpError } from '@refinedev/core';
import {
  DeleteButton,
  EditButton,
  List,
  ShowButton,
  TextField,
  useTable
} from '@refinedev/antd';
import { IEcommerceProfitCenter } from 'interfaces/ecommerce_profit_centers';

interface IFilter {
  code: string;
}

export const EcommerceProfitCenterList = () => {
  const { tableProps, searchFormProps } = useTable<
    IEcommerceProfitCenter,
    HttpError,
    IFilter
  >({
    resource: 'ecommerce/profit_centers',

    onSearch: params => {
      const filters: CrudFilters = [];
      const { code } = params;

      filters.push({
        field: 'filter[code]',
        operator: 'eq',
        value: code
      });

      return filters;
    }
  });

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <List>
          <FilterForm searchFormProps={searchFormProps}>
            <Form.Item label="Código" name="code">
              <Input placeholder="código" />
            </Form.Item>
          </FilterForm>
          <Table {...tableProps} rowKey="id">
            <Table.Column
              dataIndex="code"
              key="code"
              title="Código"
              render={value => <TextField value={value} />}
            />
            <Table.Column
              dataIndex="description"
              key="description"
              title="Descrição"
              render={value => <TextField value={value} />}
            />
            <Table.Column
              dataIndex={['division', 'code']}
              key="division"
              title="Divisão"
              render={value => <TextField value={value} />}
            />
            <Table.Column<IEcommerceProfitCenter>
              title="Ações"
              dataIndex="actions"
              align="center"
              render={(_, record) => {
                return (
                  <Space>
                    <ShowButton
                      hideText
                      size="small"
                      recordItemId={record.id}
                    />
                    <EditButton
                      hideText
                      size="small"
                      recordItemId={record.id}
                    />
                    <DeleteButton
                      size="small"
                      resource="ecommerce/profit_centers"
                      recordItemId={record.id}
                      hideText
                    />
                  </Space>
                );
              }}
            />
          </Table>
        </List>
      </Col>
    </Row>
  );
};
